import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { CompleteAnim, MplButton, MplModal } from '@mopla/ui';

interface IDTicketEditPauseSuccessModalProps {
	open: boolean;
	onClose: () => void;
	activeFromDate: string;
}

const transComponents = {
	b: <Typography variant="b2-m" component="span" color="primary.main" />,
};

export const DTicketEditPauseSuccessModal = ({
	open,
	onClose,
	activeFromDate,
}: IDTicketEditPauseSuccessModalProps) => {
	const { t } = useTranslation('dticketSubscriptionEditPause');

	const description = (
		<Typography
			variant="b2"
			color="primary.main"
			data-testid="dticket-editPauseSuccessModal-description"
		>
			<Trans
				t={t}
				i18nKey="success_modal_pause_changed.description"
				values={{ date: activeFromDate }}
				components={transComponents}
			/>
		</Typography>
	);

	return (
		<MplModal
			open={open}
			testId="DTicketSubscriptionEditPause-SuccessModalPauseChanged"
			icon={<CompleteAnim />}
			title={t('success_modal_pause_changed.title')}
			content={description}
			buttons={
				<MplButton
					variant="contained"
					color="primary"
					fullWidth
					onClick={onClose}
					testId="dticket-editPauseSuccessModal-close-button"
				>
					{t('success_modal_pause_changed.button')}
				</MplButton>
			}
		/>
	);
};
